import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Menu, Sidebar } from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import sidebarStyles from "../../../commonStyle/SideStyles";
import "../../../css/Side.css";
import { menuItems } from "../menuItems/menuList";
import CustomMenuItem from "./CustomMenu";

export const SECRET_KEY = "843567893696976453275974432697R634976";
const SideBar = () => {
  const theme = useTheme();
    const dispatch = useDispatch();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isSmallCollapsed, setIsSmallCollapsed] = useState(true);
  const [selected, setSelected] = useState("Dashboard");
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const location = useLocation();
  const loginValues = useSelector((state) => state.values?.loginValues || []);
  const userInfo = loginValues[0]?.user || {};
  const securityMenuItem = [];
  useEffect(() => {
    const userType = userInfo.user_type;
    if (userType === 1) {
      setUserName("ADMIN");
    } else if (userType === 2) {
      setUserEmail(userInfo.email);
      setUserName("DOCTOR");
    } else if (userType === 3) {
      setUserEmail(userInfo.email);
      setUserName("STAFF");
    } else if (userType === 4) {
      setUserEmail(userInfo.email);
      setUserName("SECURITY");
    }
  }, []);
  const classes = sidebarStyles(theme);
  const userType = userInfo.user_type;
  // const menuToDisplay =
  //   userType === 2
  //     ? doctorMenuItem
  //     : userType === 3
  //     ? staffMenuItem
  //     : userType === 4
  //     ? securityMenuItem
  //     : menuItems;
  useEffect(() => {
    setSelected(location.pathname);
  }, [location.pathname]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 565) {
        setIsSmallCollapsed(true);
      } else if (window.innerWidth < 650) {
        setIsSmallCollapsed(true);
      } else {
        setIsSmallCollapsed(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleSubmenu = (key) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  // const closeOtherSubmenus = (key) => {
  //   setOpenSubmenus((prev) => {
  //     const newState = { ...prev };
  //     Object.keys(newState).forEach((submenuKey) => {
  //       if (submenuKey !== key) {
  //         newState[submenuKey] = false;
  //       }
  //     });
  //     return newState;
  //   });
  // };
  const toggleSidebar = () => {
    if (window.innerWidth < 650) {
      setIsSmallCollapsed((prev) => !prev);
    } else {
      setIsCollapsed((prev) => !prev);
    }
  };


  const closeOtherSubmenus = (key) => {

    const keepPatientOpen = key !== 'patient' && openSubmenus['patient'];
    
    setOpenSubmenus((prev) => {
      const newState = Object.keys(prev).reduce((acc, k) => {
        acc[k] = k === key;
        return acc;
      }, {});
      
  
      if (keepPatientOpen) {
        newState['patient'] = true;
      }
      
      return newState;
    });
  };
  const permissions =
    typeof userInfo?.access === "string"
      ? JSON.parse(userInfo?.access)
      : userInfo?.access || {};

  const getMenuFromPermissions = (menuItems, permissions) => {
    return menuItems
      .map((item) => {
        if (
          userType === 1 &&
          (item.key === "dashboard" ||
           item.key === "staffProfile" ||
           item.key === "doctorProfile" ||
           item.key === "patientTransfer" ||
           item.key === "staffPatientList" )
        ) {
          return null;
        }
        if (item.key === "logout" || item.key === "changePassword") {
          return item;
        }
  
        const perm = permissions[item.key] || {};
        if (item.submenu) {
          const filteredSubmenu = item.submenu.filter((sub) => {
            const requiredPermission = sub.permission;
            return (
              userType === 1 || 
              (perm[requiredPermission] && !perm.noaccess)
            );
          });
          return filteredSubmenu.length > 0
            ? { ...item, submenu: filteredSubmenu }
            : null;
        }
        return (
          userType === 1 ||
          ((perm.view || perm.allaccess) && !perm.noaccess)
        )
          ? item
          : null;
      })
      .filter(Boolean);
  };
  
  const menuToDisplay = getMenuFromPermissions(menuItems, permissions);

  return (
    <Box sx={{ display: "flex" }}>
      {window.innerWidth < 650 && !isSmallCollapsed && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSmallCollapsed(true)}
        />
      )}
      <Box sx={classes.sidebarContainer}>
        <Sidebar
          collapsed={window.innerWidth < 650 ? isSmallCollapsed : isCollapsed}
          sx={{
            backgroundColor: "#119BAB",
          }}
        >
          <Box sx={classes.sidebarHeader}>
            {!(window.innerWidth < 650 ? isSmallCollapsed : isCollapsed) && (
              <Typography
                variant="h1"
                style={{
                  color: "white",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                {userName}
              </Typography>
            )}
            <IconButton style={classes.toggle} onClick={toggleSidebar}>
              <MenuOutlinedIcon />
            </IconButton>
          </Box>
          <PerfectScrollbar
            options={{ suppressScrollX: true, wheelPropagation: false }}
            style={{
              ...classes.scrollableMenu,
              ...(isCollapsed || isSmallCollapsed
                ? classes.menuContainerClosed
                : {}),
            }}
          >
            <Menu iconShape="square">
              {menuToDisplay.map((menuItem) => {
                const isParentActive =
                  selected === menuItem.url ||
                  (menuItem.submenu &&
                    menuItem.submenu.some(
                      (submenu) => submenu.url === selected
                    )) ||
                  (menuItem.key === "patient" &&
                    selected.startsWith("/patient")) ||
                  (menuItem.key === "doctor" &&
                    selected.startsWith("/doctor")) ||
                  (menuItem.key === "staff" && selected.startsWith("/staff")) ||
                  (menuItem.key === "securityOfficer" &&
                    selected.startsWith("/securityOfficer")) ||
                  (menuItem.key === "securityOfficer" &&
                    selected.startsWith("/securityOfficer")) ||
                    (menuItem.key === "admissions" && selected.startsWith("/admission"));

                return (
                  <React.Fragment key={menuItem.key}>
                    <Link
                      to={menuItem.url || "#"}
                      style={classes.menuLinkStyle}
                    >
                      <CustomMenuItem
                        icon={menuItem.icon}
                        isCollapsed={
                          window.innerWidth < 650
                            ? isSmallCollapsed
                            : isCollapsed
                        }
                        isActive={isParentActive}
                        hasSubmenu={!!menuItem.submenu}
                        isSubmenuOpen={openSubmenus[menuItem.key]}
                        onClick={() => {
                          if (menuItem.url) setSelected(menuItem.url);
                          if (menuItem.submenu) {
                            toggleSubmenu(menuItem.key);
                            closeOtherSubmenus(menuItem.key);
                          }
                        }}
                      >
                        {!(window.innerWidth < 650
                          ? isSmallCollapsed
                          : isCollapsed) && menuItem.label}
                      </CustomMenuItem>
                    </Link>
                    {menuItem.submenu &&
                      openSubmenus[menuItem.key] &&
                      !(window.innerWidth < 650
                        ? isSmallCollapsed
                        : isCollapsed) && (
                        <Box sx={classes.submenuBox}>
                          {menuItem.submenu.map((submenuItem, idx) => (
                            <Link
                              to={submenuItem.url}
                              key={`${menuItem.key}-${idx}`}
                              style={classes.menuLinkStyle}
                            >
                              <CustomMenuItem
                                icon={submenuItem.icon}
                                isActive={selected === submenuItem.url}
                                onClick={() => setSelected(submenuItem.url)}
                                sx={{
                                  backgroundColor: "white",
                                }}
                              >
                                {submenuItem.name}
                              </CustomMenuItem>
                            </Link>
                          ))}
                        </Box>
                      )}
                  </React.Fragment>
                );
              })}
            </Menu>
          </PerfectScrollbar>
        </Sidebar>
      </Box>
    </Box>
  );
};
export default SideBar;